import classes from "./styles.module.scss";
import * as components from "./components";

export const Content = ({ items, additionalComponents }) => {
  const allowedComponents = {
    ...components,
    ...additionalComponents,
  };

  return (
    <div className={classes.content}>
      {items.map(({ component, id, props }, k) => (
        <div key={k}>
          {id && <a id={id} />}
          {(() => {
            if (typeof component !== "undefined" && component in allowedComponents) {
              const Component = allowedComponents[component];

              return <Component {...props} />;
            }
          })()}
        </div>
      ))}
    </div>
  );
};

Content.defaultProps = {
  items: [],
  additionalComponents: {},
};
